import { useMsal } from "@azure/msal-react";
import Cookies from "js-cookie";
import { CookiesKeys } from "../../Constants/Consts";
import { persistor } from "../../store/store";
import { useCallback } from "react";
import { toast } from "react-toastify";

const LogoutButton = () => {
    const { instance } = useMsal();

    const handleLogout = useCallback(async () => {
        try {
            await persistor.purge();
            await instance.logoutRedirect();
            Cookies.set(CookiesKeys.loginPlatform, null);
        } catch (error) {
            toast.error("Logout failed. Please try again.");
            console.error({ error });
        }
    }, [instance]);

    return (
        <button data-testid="logout-button" onClick={handleLogout}>Logout</button>
    );
};

export default LogoutButton;

